import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {DeadlineStickerValue, SystemStickerType} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {useStickerStore} from '@components/sticker/sticker-store'
import {Gantt} from '@extensions/gantt'
import {DeadlineEdit} from '@extensions/sticker/views-web/deadline/deadline-edit'
import {Task} from '@extensions/task'

export const StickerMenuDeadlineTask = observer(() => {
  const [state, store] = useStickerStore()

  const setCurrentValue = (value: DeadlineStickerValue) => {
    store.setStickerValue(value)
    store.pinStickerValue()
    store.syncIsRunningTimer()
  }

  const forbidUnpin =
    Task.shouldAutoPlan(store.stickerTask) &&
    (Gantt.getLinkedFromHubs(store.stickerTask).length > 0 ||
      Gantt.getLinksToHubs(store.stickerTask).length > 0)

  const canEdit =
    !store.stickerTask ||
    PermissionsChecker.checkEditTaskStickers(
      store.stickerTask,
      store.sticker,
      undefined
    )

  return (
    <div className="min-w-[248px]">
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={
            Lang.msg.stickerNames[
              store.stickerData.stickerType as SystemStickerType
            ]
          }
          showUnpin={!forbidUnpin && canEdit}
        />
      </div>
      <div className="sticker-item-list-body">
        <DeadlineEdit
          val={state.value as DeadlineStickerValue}
          setCurrentValue={setCurrentValue}
          task={store.stickerTask}
          canEdit={canEdit}
        />
      </div>
    </div>
  )
})
